import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RestEndpoints } from "../../../../api/endpoints";
import getInstance from "../../../../utils/rest";
import { IPomSaveDraftModel } from "../../../models/reportings/pom-reporting-draft.model";
import { PomQueryKeys } from "../../../pom-query-keys";

const saveReportingDraft = async (
  contractNo: string,
  reportingNo: number,
  request: IPomSaveDraftModel,
): Promise<void> => {
  await getInstance().put(
    `${RestEndpoints.PomReportingDrafts}/${contractNo}/${reportingNo}`,
    request,
  );
};

export const useSaveReportingDraftMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      contractNo,
      reportingNo,
      request,
    }: {
      contractNo: string;
      reportingNo: number;
      request: IPomSaveDraftModel;
    }) => saveReportingDraft(contractNo, reportingNo, request),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [PomQueryKeys.GetReportingDraft, variables.contractNo, variables.reportingNo],
      });
      queryClient.invalidateQueries({
        queryKey: [PomQueryKeys.GetReportingDraftNos, variables.contractNo],
      });
    },
  });
};
